import { render, staticRenderFns } from "./SettingUser.vue?vue&type=template&id=5fdb18e6&scoped=true"
import script from "./SettingUser.vue?vue&type=script&lang=js"
export * from "./SettingUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdb18e6",
  null
  
)

export default component.exports